<template>
  <BaseModal :open="visible" @update:open="handleModalClose" title="修改密码" :width="450">
    <a-form :model="formData" :rules="formRules" ref="formRef" layout="vertical" width="400">
      <a-form-item label="原密码" name="oldPassword">
        <a-input-password
          v-model:value="formData.oldPassword"
          placeholder="请输入原密码"
          :maxlength="20"
          show-count
        />
      </a-form-item>
      <a-form-item label="新密码" name="newPassword">
        <a-input-password
          v-model:value="formData.newPassword"
          placeholder="请输入新密码"
          :maxlength="20"
          show-count
        />
      </a-form-item>
      <a-form-item label="确认新密码" name="confirmNewPassword">
        <a-input-password
          v-model:value="formData.confirmNewPassword"
          placeholder="请再次输入新密码"
          :maxlength="20"
          show-count
        />
      </a-form-item>
    </a-form>

    <template #footer>
      <a-space>
        <a-button @click="handleCancel">取消</a-button>
        <a-button type="primary" @click="handleSubmit" :loading="loading">确认修改</a-button>
      </a-space>
    </template>
  </BaseModal>
</template>

<script setup lang="ts">
import { ref, reactive } from 'vue'
import { message } from 'ant-design-vue'
import BaseModal from '@/components/baseModal/index.vue'
import { updatePassword } from '@/api/admin'

defineOptions({
  name: 'ChangePasswordModal',
})

const props = defineProps<{
  visible: boolean
}>()

const emit = defineEmits<{
  (e: 'update:visible', value: boolean): void
}>()

const formRef = ref()
const loading = ref(false)

const formData = reactive({
  oldPassword: '',
  newPassword: '',
  confirmNewPassword: '',
})

const formRules = {
  oldPassword: [
    { required: true, message: '请输入原密码', trigger: 'blur' },
    { min: 6, message: '密码长度不能少于6位', trigger: 'blur' },
  ],
  newPassword: [
    { required: true, message: '请输入新密码', trigger: 'blur' },
    { min: 6, message: '密码长度不能少于6位', trigger: 'blur' },
  ],
  confirmNewPassword: [
    { required: true, message: '请确认新密码', trigger: 'blur' },
    {
      validator: (rule: any, value: string) => {
        if (value !== formData.newPassword) {
          return Promise.reject(new Error('两次输入的密码不一致'))
        }
        return Promise.resolve()
      },
      trigger: 'blur',
    },
  ],
}

const handleCancel = () => {
  emit('update:visible', false)
  resetForm()
}

const handleModalClose = () => {
  emit('update:visible', false)
  resetForm()
}

const resetForm = () => {
  formData.oldPassword = ''
  formData.newPassword = ''
  formData.confirmNewPassword = ''
  formRef.value?.resetFields()
}

const handleSubmit = async () => {
  try {
    await formRef.value?.validate()
    loading.value = true
    await updatePassword({
      oldPassword: formData.oldPassword,
      newPassword: formData.newPassword,
      confirmNewPassword: formData.confirmNewPassword,
    })
    message.success('密码修改成功')
    emit('update:visible', false)
    resetForm()
  } catch (error) {
    console.error('修改密码失败:', error)
  } finally {
    loading.value = false
  }
}
</script>
